<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="col-md-12 px-0">
                <router-link class="back-route h3" ref="backBtn" to="/results">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    Users
                </router-link>
            </div>
        </div>

        <div class="tabcontent">
            <div class="fullInputs mb-4 pt-3">
                <div class="twoInputs">
                    <div class="btnInsideInput">
                        <input type="text" id="free_search" class="form-control" v-model="search"
                               placeholder="Search" autocomplete="off"
                               @input="searchComeptition" maxlength="50">

                        <button @click="searchBackEndHandler" ref="buttonSearch">
                            <img src="../../../assets/images/SearchIcon.png" alt="">
                        </button>
                    </div>
                </div>
                <div class="oneInput">
                    <select id="filter_dates" class="form-select" v-model="sort" @change="getUsersScored">
                        <option value="false" selected disabled >Sort by Date</option>
                        <option value="asc">Oldest</option>
                        <option value="desc">Latest</option>
                    </select>
                </div>
            </div>

            <div class="table-container" v-if="users.length > 0">
                <TableComponent :thead="thead" :tbody="users" :keys="keys" @sort="SortCompetition" @update="updateCompetition"
                                model="userScoreIndividual" name="userScoreIndividual"
                                updateUrl="/edit-scores" />

                <div class="paginationLink">
                    <pagination :data="laravelData" @pagination-change-page="getUsersScored" :limit="3">
                        <template #prev-nav>
                            <span>Previous</span>
                        </template>
                        <template #next-nav>
                            <span>Next</span>
                        </template>
                    </pagination>
                </div>
            </div>

            <div v-else class="text-center">No User Answer</div>

        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";
    import repository from "../../../api-services/repository";
    import getQuestionType from "../../../helpers/getQuestionName";

    export default {
        name:'pageShowUser-userscore',
        data(){
            return {
                // thead: ['Name' , 'Score' , 'Percentage' , 'true Or False' , 'Multiple Choice' , 'Free Text' , 'Slides' , 'Rank'],
                thead:['Name' , 'Score' , 'Percentage'],
                keys: ['name' , 'score', 'percentage'],
                permissions: [],
                users: [],
                filteredArray: [],
                originalUsers: [],
                laravelData: {},
                error: null,
                scorePerQuestion:[],
                search: '',
                sort: false,
                state: false,
                isSearch:false,
                isActive1:false,
                isActive2:false,
                status2:false,
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        mounted(){
            this.getUsersScored();
        },
        methods:{
            async getUsersScored(page=1){
                const competition_id = this.$route.params.id;
                try{
                    this.thead = ['Name' , 'Score' , 'Percentage'];
                    this.keys = ['name' , 'score', 'percentage'];
                    const response = await score.usersOfCompetition(competition_id , false , this.sort === false ? this.sort = 'desc' : this.sort , page);
                    this.thead.push(...response.data.data[0].titles);
                    this.keys.push(...response.data.data[0].keysData);
                    this.users = response.data.data;
                    this.laravelData = response.data;
                    this.originalUsers = response.data.data;

                }catch (e) {
                    // console.log(e);
                }
            },
            async SortCompetition(){
                let status = !this.status2;
                this.originalUsers.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateCompetition(e){
                let filteredData = this.users.filter(function (data) {
                    return data.id != e;
                });
                this.users = filteredData;
            },
            searchComeptition(e){
                let searchedValue = e.target.value;
                let searchedData = this.originalUsers.filter((data) => data.name.includes(searchedValue));
                this.users = searchedData;
            },
            async searchBackEndHandler(){
                await this.getUsersScored();
            }
        }
    }
</script>

<style scoped>
    .styleDataNotFound{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        height: 80%;
    }
</style>